@if (optionMode) {
  <!--
    a11y: WAI-ARIA combobox-autocomplete-list pattern.
    Listbox option — NOT a button. DOM focus stays on the combobox input;
    selection is performed by the parent via aria-activedescendant + Enter,
    or by a mouse click on this option. `mousedown.preventDefault` keeps the
    input focused so blur doesn't dismiss the listbox before click fires.
  -->
  <li
    [id]="optionId"
    role="option"
    [attr.aria-selected]="isActive ? 'true' : 'false'"
    [attr.aria-disabled]="disabled ? 'true' : null"
    tabindex="-1"
    class="flex gap-2 items-center w-full rounded p-1 text-start text-inherit list-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#0C3058]"
    [class.cursor-pointer]="!disabled"
    [class.cursor-not-allowed]="disabled"
    [class.opacity-50]="disabled"
    [class.bg-primary-50]="isActive"
    (mousedown)="preventFocusSteal($event)"
    (focus)="emitOptionFocus()"
    (click)="handleClick()"
    >
    <ng-icon
      [name]="icon"
      [ngClass]="{ 'colored-icon': icon === 'station' }"
      class="text-xl shrink-0"
      aria-hidden="true"
    ></ng-icon>
    <span class="flex flex-col flex-1 min-w-0">
      @if (main) {
        <span class="font-bold text-sm">{{ main }}</span>
      }
      @if (sub) {
        <small
          class="text-sm font-normal"
          [ngClass]="isSubBlue ? 'text-[#0068F5]' : 'text-[#5C748F]'"
          >{{ sub }}</small
          >
        }
      </span>
    </li>
} @else {
  <!--
    a11y: native <button> is announced as "button"; aria-haspopup tells SR users
    that activating this button opens a separate popup (typically a "dialog")
    rather than just selecting the current row.
  -->
  <button
    type="button"
    class="flex gap-2 items-center w-full cursor-pointer rounded bg-transparent p-0 text-start border-0 text-inherit disabled:cursor-not-allowed disabled:opacity-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#0C3058]"
    [disabled]="!!disabled"
    [attr.aria-haspopup]="ariaHasPopup"
    (click)="handleClick()"
    >
    <ng-icon
      [name]="icon"
      [ngClass]="{ 'colored-icon': icon === 'station' }"
      class="text-xl shrink-0"
      aria-hidden="true"
    ></ng-icon>
    <span class="flex flex-col flex-1 min-w-0">
      @if (main) {
        <span class="font-bold text-sm">{{ main }}</span>
      }
      @if (sub) {
        <small
          class="text-sm font-normal"
          [ngClass]="isSubBlue ? 'text-[#0068F5]' : 'text-[#5C748F]'"
          >{{ sub }}</small
          >
        }
      </span>
    </button>
}
